import {tabsAnatomy} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const {definePartsStyle} = createMultiStyleConfigHelpers(tabsAnatomy.keys);

export const indicator = definePartsStyle(() => {
  return {
    tablist: {
      borderRadius: `lg`,
      // borderWidth: `px`,
      bg: `background.body`,
      px: `8`,
      gap: `24`,
      h: `40`,
      boxShadow: `4.inset`,
    },
    tab: {
      lineHeight: `1.25rem`,
      fontSize: `base`,
      color: `text.base`,
      zIndex: 1,
      px: `8`,
      _selected: {
        color: `text.inverse`,
      },
    },
    indicator: {
      borderRadius: `md`,
      // TODO: replace bg to design tokens
      bg: `brand.light`,
      border: `none`,
      h: `28`,
      marginTop: `-34`,
      _dark: {
        bg: `hsl(199 96.4% 56.1% / 0.1)`,
      },
    },
  };
});
